// extracted by mini-css-extract-plugin
module.exports = {"grid":"Range_grid__Dbn70"};